import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import PayslipUploadFinalizeRequest from "../request/PayslipUploadFinalizeRequest";

const FinalizePayslipDocumentsApiService = async (
  request: PayslipUploadFinalizeRequest
): Promise<boolean> => {
  const url = `/document_processing_jobs/${request.job_id}/finalize/`;
  const fileData = new FormData();
  // eslint-disable-next-line
  // @ts-ignore
  Object.keys(request).forEach((it) => fileData.append(it, request[it]));
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  const { data } = await axios.post(url, fileData, config);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useUploadPayslipDocumentFinalizeApiService = () =>
  useMutation<boolean, AxiosError, PayslipUploadFinalizeRequest>(
    FinalizePayslipDocumentsApiService,
    {
      mutationKey: ["FinalizePayslipDocumentsApiService"],
    }
  );

export default useUploadPayslipDocumentFinalizeApiService;
